import { render, staticRenderFns } from "./classificationModal.vue?vue&type=template&id=7dd201c7&scoped=true&"
import script from "./classificationModal.vue?vue&type=script&lang=js&"
export * from "./classificationModal.vue?vue&type=script&lang=js&"
import style0 from "./classificationModal.vue?vue&type=style&index=0&id=7dd201c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd201c7",
  null
  
)

export default component.exports